// extracted by mini-css-extract-plugin
export default {"provider":"ProviderSelector_provider__Hqu5r","label":"ProviderSelector_label__8krxi","select":"ProviderSelector_select__WE5Ks"};